import React, { useCallback, useEffect, useRef, useState } from "react";
import steps from "./Steps.json";

const HowItWorks = () => {
  // const [selectedStep, setSelectedStep] = useState("PickupScreen");

  const [selectedStep, setSelectedStep] = useState(steps[0].image);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false); // Prevents rapid scroll events
  const sectionRef = useRef(null);
  const isFullScreen = false;

  const handleScroll = useCallback(
    (event) => {
      if (isTransitioning) return; // Prevent multiple scroll triggers

      event.preventDefault();
      event.stopPropagation();

      setIsTransitioning(true);

      requestAnimationFrame(() => {
        if (event.deltaY > 0 && currentIndex < steps.length - 1) {
          setCurrentIndex((prev) => prev + 1);
        } else if (event.deltaY < 0 && currentIndex > 0) {
          setCurrentIndex((prev) => prev - 1);
        }

        // Delay to allow transition effect
        setTimeout(() => {
          setIsTransitioning(false);
        }, 900); // Adjust time based on transition duration
      });
    },
    [currentIndex, steps.length, isTransitioning]
  );

  useEffect(() => {
    const section = sectionRef.current;
    if (!section) return;

    section.addEventListener("wheel", handleScroll, { passive: false });

    return () => {
      section.removeEventListener("wheel", handleScroll);
    };
  }, [handleScroll]);

  useEffect(() => {
    setSelectedStep(steps[currentIndex]?.image || steps[0].image);
  }, [currentIndex]);

  return (
    <div
      // className="flex flex-col gap-14 justify-center items-center px-4"
      className={`flex flex-col gap-14 justify-center items-center lg:overflow-hidden px-4 transition-all duration-500 ${
        isFullScreen ? "fixed top-0 left-0 w-full h-screen bg-white z-50" : ""
      }`}
      ref={sectionRef}
    >
      <div className="flex flex-col gap-4 leading-[150%] justify-center items-center">
        <h2 className="font-semibold text-4xl ">How it Works?</h2>
        <h5 className="font-medium text-xl ">
          3 Simple Steps to Instant Delivery
        </h5>
      </div>

      {/* desktop view */}
      {/* <div className="lg:flex hidden gap-[104px]">
        <div className="flex flex-col gap-8">
          {steps.map((step) => (
            <div
              className={`w-[545px] h-[156px] rounded-3xl p-6 flex flex-col gap-3 cursor-pointer ${
                selectedStep === step.image
                  ? "border border-[#E5204B] border-opacity-50"
                  : ""
              }`}
              onClick={() => setSelectedStep(step.image)}
            >
              <h3 className="text-[28px] font-semibold text-[#E5204B]">
                {step.title}
              </h3>
              <p className="text-[#181818] font-medium text-base">
                {step.desc}
              </p>
            </div>
          ))}
        </div>
        <div className="w-[651px] h-[568px] bg-[#124DAB] rounded-[48px] relative">
          <div className="absolute bottom-0 left-8">
            <img src={`/Images/phoneScreens/${selectedStep}.svg`} alt="" />
          </div>
        </div>
      </div> */}
      <div
        // ref={sectionRef}
        className="lg:flex hidden gap-[104px] overflow-hidden"
      >
        <div className="flex flex-col gap-8">
          {steps.map((step, index) => (
            <div
              key={step.image}
              className={`w-[545px] h-[156px] rounded-3xl p-6 flex flex-col gap-3 cursor-pointer shadow-sm ${
                selectedStep === step.image
                  ? "border border-[#E5204B] border-opacity-50"
                  : ""
              } hover:border hover:border-[#E5204B] hover:border-opacity-50 `}
              onClick={() => {
                setSelectedStep(step.image);
                setCurrentIndex(index);
              }}
            >
              <h3 className="text-[28px] font-semibold text-[#E5204B]">
                {step.title}
              </h3>
              <p className="text-[#181818] font-medium text-base">
                {step.desc}
              </p>
            </div>
          ))}
        </div>
        <div className="w-[651px] h-[568px] bg-[#124DAB] rounded-[48px] relative">
          <div className="absolute bottom-0 ">
            <img src={`/Images/phoneScreens/${selectedStep}.png`} alt="" />
          </div>
        </div>
      </div>

      {/* Mobile view */}
      <div className="lg:hidden flex flex-col gap-10">
        {steps.map((data) => (
          <div className="w-[361px] h-[438px] flex flex-col gap-6 rounded-3xl overflow-hidden manual-shadow">
            <div className="w-full h-[284px] bg-[#124DAB]  relative flex justify-center">
              <div className="absolute bottom-0   w-[320px] ">
                <img src={`/Images/phoneScreens/${data.image}.png`} alt="" />
              </div>
            </div>
            <div className="px-6 flex flex-col justify-center gap-2 items-center text-center">
              <h3 className="text-[#E5204B] font-semibold text-2xl">
                {data.title}
              </h3>
              <p className="text-[#181818] font-medium opacity-60 text-xs leading-[180%]">
                {data.desc}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

function throttle(func, limit) {
  let inThrottle;
  return function (...args) {
    if (!inThrottle) {
      func(...args);
      inThrottle = true;
      setTimeout(() => (inThrottle = false), limit);
    }
  };
}

export default HowItWorks;
